webpackJsonp([8],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Loading__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    LoadingView: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Loading__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.$store.state.screenWidth = window.innerWidth;
      // this.$store.state.screenHeight = window.innerHeight
    }
  },
  mounted: function mounted() {
    window.addEventListener('popstate', function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('theme-light');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('modal-open');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('div').removeClass('modal-backdrop');
    });
  }
});

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(192);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  OAuthCheck: function OAuthCheck(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'user/check', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getProfile: function getProfile(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'user/profile', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  registerUser: function registerUser(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'user/register', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateProfile: function updateProfile(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'user/update', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getWorkshop: function getWorkshop(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'workshop', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getMyWorkShop: function getMyWorkShop(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'user/workshop', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addMyWorkShop: function addMyWorkShop(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'workshop/register', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addAssessment: function addAssessment(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'workshop/assessment', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dashboard: function dashboard(URL, date, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'dashboard/' + date, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  schoolData: function schoolData(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'school', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getProvince: function getProvince(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'ref/province', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getCampus: function getCampus(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'ref/campus', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getFaculty: function getFaculty(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'ref/faculty', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getDepartment: function getDepartment(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'ref/department', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getMajor: function getMajor(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'ref/major', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getConfig: function getConfig(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'config', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkinAuth: function checkinAuth(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'checkin/auth', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  checkinRegister: function checkinRegister(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'checkin/register', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_index__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_mixin_js__ = __webpack_require__(200);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









window.$ = window.jQuery = __WEBPACK_IMPORTED_MODULE_5_jquery___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93b9cc84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(166);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93b9cc84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06625379_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(165);
function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06625379"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06625379_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-card",attrs:{"role":"status","aria-live":"polite"}},[_c('div',{staticClass:"loading-mark"},[_c('span'),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/mascot/rmutl-heart.png","alt":"RMUTL mascot"}})]),_vm._v(" "),_c('strong',[_vm._v("กำลังประมวลผล")]),_vm._v(" "),_c('small',[_vm._v("โปรดรอสักครู่")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid m-0 p-0"},[_c('router-view'),_vm._v(" "),(_vm.$store.state.isLoading)?_c('LoadingView'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(168);


var Login = function Login() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 205));
};
var Regis = function Regis() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 206));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 207));
};
var Workshop = function Workshop() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 208));
};
var Activity = function Activity() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 209));
};
var Profile = function Profile() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 210));
};
var Checkin = function Checkin() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 211));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var titlename = 'RMUTL OPEN HOUSE เปิดบ้านราชมงคลล้านนา';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: '' }
  }, {
    path: '/regis/:id',
    name: 'Regis',
    component: Regis,
    meta: { title: 'Register' }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { title: 'Dashboard' }
  }, {
    path: '/workshop',
    name: 'Workshop',
    component: Workshop,
    meta: { title: 'Workshop' }
  }, {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: { title: 'Activity' }
  }, {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { title: 'Profile' }
  }, {
    path: '/checkin',
    name: 'Checkin',
    component: Checkin,
    meta: { title: 'Checkin' }
  }]
});

router.afterEach(function (to, from) {
  document.title = to.meta.title ? to.meta.title + ' | ' + titlename : titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 20,
	"./af.js": 20,
	"./ar": 21,
	"./ar-dz": 22,
	"./ar-dz.js": 22,
	"./ar-kw": 23,
	"./ar-kw.js": 23,
	"./ar-ly": 24,
	"./ar-ly.js": 24,
	"./ar-ma": 25,
	"./ar-ma.js": 25,
	"./ar-sa": 26,
	"./ar-sa.js": 26,
	"./ar-tn": 27,
	"./ar-tn.js": 27,
	"./ar.js": 21,
	"./az": 28,
	"./az.js": 28,
	"./be": 29,
	"./be.js": 29,
	"./bg": 30,
	"./bg.js": 30,
	"./bm": 31,
	"./bm.js": 31,
	"./bn": 32,
	"./bn-bd": 33,
	"./bn-bd.js": 33,
	"./bn.js": 32,
	"./bo": 34,
	"./bo.js": 34,
	"./br": 35,
	"./br.js": 35,
	"./bs": 36,
	"./bs.js": 36,
	"./ca": 37,
	"./ca.js": 37,
	"./cs": 38,
	"./cs.js": 38,
	"./cv": 39,
	"./cv.js": 39,
	"./cy": 40,
	"./cy.js": 40,
	"./da": 41,
	"./da.js": 41,
	"./de": 42,
	"./de-at": 43,
	"./de-at.js": 43,
	"./de-ch": 44,
	"./de-ch.js": 44,
	"./de.js": 42,
	"./dv": 45,
	"./dv.js": 45,
	"./el": 46,
	"./el.js": 46,
	"./en-au": 47,
	"./en-au.js": 47,
	"./en-ca": 48,
	"./en-ca.js": 48,
	"./en-gb": 49,
	"./en-gb.js": 49,
	"./en-ie": 50,
	"./en-ie.js": 50,
	"./en-il": 51,
	"./en-il.js": 51,
	"./en-in": 52,
	"./en-in.js": 52,
	"./en-nz": 53,
	"./en-nz.js": 53,
	"./en-sg": 54,
	"./en-sg.js": 54,
	"./eo": 55,
	"./eo.js": 55,
	"./es": 56,
	"./es-do": 57,
	"./es-do.js": 57,
	"./es-mx": 58,
	"./es-mx.js": 58,
	"./es-us": 59,
	"./es-us.js": 59,
	"./es.js": 56,
	"./et": 60,
	"./et.js": 60,
	"./eu": 61,
	"./eu.js": 61,
	"./fa": 62,
	"./fa.js": 62,
	"./fi": 63,
	"./fi.js": 63,
	"./fil": 64,
	"./fil.js": 64,
	"./fo": 65,
	"./fo.js": 65,
	"./fr": 66,
	"./fr-ca": 67,
	"./fr-ca.js": 67,
	"./fr-ch": 68,
	"./fr-ch.js": 68,
	"./fr.js": 66,
	"./fy": 69,
	"./fy.js": 69,
	"./ga": 70,
	"./ga.js": 70,
	"./gd": 71,
	"./gd.js": 71,
	"./gl": 72,
	"./gl.js": 72,
	"./gom-deva": 73,
	"./gom-deva.js": 73,
	"./gom-latn": 74,
	"./gom-latn.js": 74,
	"./gu": 75,
	"./gu.js": 75,
	"./he": 76,
	"./he.js": 76,
	"./hi": 77,
	"./hi.js": 77,
	"./hr": 78,
	"./hr.js": 78,
	"./hu": 79,
	"./hu.js": 79,
	"./hy-am": 80,
	"./hy-am.js": 80,
	"./id": 81,
	"./id.js": 81,
	"./is": 82,
	"./is.js": 82,
	"./it": 83,
	"./it-ch": 84,
	"./it-ch.js": 84,
	"./it.js": 83,
	"./ja": 85,
	"./ja.js": 85,
	"./jv": 86,
	"./jv.js": 86,
	"./ka": 87,
	"./ka.js": 87,
	"./kk": 88,
	"./kk.js": 88,
	"./km": 89,
	"./km.js": 89,
	"./kn": 90,
	"./kn.js": 90,
	"./ko": 91,
	"./ko.js": 91,
	"./ku": 92,
	"./ku.js": 92,
	"./ky": 93,
	"./ky.js": 93,
	"./lb": 94,
	"./lb.js": 94,
	"./lo": 95,
	"./lo.js": 95,
	"./lt": 96,
	"./lt.js": 96,
	"./lv": 97,
	"./lv.js": 97,
	"./me": 98,
	"./me.js": 98,
	"./mi": 99,
	"./mi.js": 99,
	"./mk": 100,
	"./mk.js": 100,
	"./ml": 101,
	"./ml.js": 101,
	"./mn": 102,
	"./mn.js": 102,
	"./mr": 103,
	"./mr.js": 103,
	"./ms": 104,
	"./ms-my": 105,
	"./ms-my.js": 105,
	"./ms.js": 104,
	"./mt": 106,
	"./mt.js": 106,
	"./my": 107,
	"./my.js": 107,
	"./nb": 108,
	"./nb.js": 108,
	"./ne": 109,
	"./ne.js": 109,
	"./nl": 110,
	"./nl-be": 111,
	"./nl-be.js": 111,
	"./nl.js": 110,
	"./nn": 112,
	"./nn.js": 112,
	"./oc-lnc": 113,
	"./oc-lnc.js": 113,
	"./pa-in": 114,
	"./pa-in.js": 114,
	"./pl": 115,
	"./pl.js": 115,
	"./pt": 116,
	"./pt-br": 117,
	"./pt-br.js": 117,
	"./pt.js": 116,
	"./ro": 118,
	"./ro.js": 118,
	"./ru": 119,
	"./ru.js": 119,
	"./sd": 120,
	"./sd.js": 120,
	"./se": 121,
	"./se.js": 121,
	"./si": 122,
	"./si.js": 122,
	"./sk": 123,
	"./sk.js": 123,
	"./sl": 124,
	"./sl.js": 124,
	"./sq": 125,
	"./sq.js": 125,
	"./sr": 126,
	"./sr-cyrl": 127,
	"./sr-cyrl.js": 127,
	"./sr.js": 126,
	"./ss": 128,
	"./ss.js": 128,
	"./sv": 129,
	"./sv.js": 129,
	"./sw": 130,
	"./sw.js": 130,
	"./ta": 131,
	"./ta.js": 131,
	"./te": 132,
	"./te.js": 132,
	"./tet": 133,
	"./tet.js": 133,
	"./tg": 134,
	"./tg.js": 134,
	"./th": 135,
	"./th.js": 135,
	"./tk": 136,
	"./tk.js": 136,
	"./tl-ph": 137,
	"./tl-ph.js": 137,
	"./tlh": 138,
	"./tlh.js": 138,
	"./tr": 139,
	"./tr.js": 139,
	"./tzl": 140,
	"./tzl.js": 140,
	"./tzm": 141,
	"./tzm-latn": 142,
	"./tzm-latn.js": 142,
	"./tzm.js": 141,
	"./ug-cn": 143,
	"./ug-cn.js": 143,
	"./uk": 144,
	"./uk.js": 144,
	"./ur": 145,
	"./ur.js": 145,
	"./uz": 146,
	"./uz-latn": 147,
	"./uz-latn.js": 147,
	"./uz.js": 146,
	"./vi": 148,
	"./vi.js": 148,
	"./x-pseudo": 149,
	"./x-pseudo.js": 149,
	"./yo": 150,
	"./yo.js": 150,
	"./zh-cn": 151,
	"./zh-cn.js": 151,
	"./zh-hk": 152,
	"./zh-hk.js": 152,
	"./zh-mo": 153,
	"./zh-mo.js": 153,
	"./zh-tw": 154,
	"./zh-tw.js": 154
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(198);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  // URL: 'http://localhost/open_house/api/',
  URL: 'https://openhouse.rmutl.ac.th/api/',
  isLoading: false,
  screenWidth: 375,
  user: {
    userId: '',
    citizenId: '',
    fullname: '',
    email: '',
    tel: '',
    school: '',
    facId: '',
    facName: '',
    depName: ''
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);




var numeral = __webpack_require__(202);
var moment = __webpack_require__(0);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      header: {
        headers: {
          'Access-Token': localStorage.token,
          'Public-Token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiT3BlbiBIb3VzZSBSTVVUTCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMi0wOS0wOSAwOTowOTowOSJ9.s8p__DdvjrhZAJAN0Nc8CVV1TnaGHPvXR7NMg-OSl80'
        }
      }
    };
  },

  methods: {
    THAIIDCHECK: function THAIIDCHECK(idCardNumber) {
      if (typeof idCardNumber === 'number') {
        idCardNumber = idCardNumber.toString();
      }

      var regex = /^[0-9]\d*$/;
      if (idCardNumber.length === 13 && idCardNumber.match(regex) && idCardNumber !== null && idCardNumber !== 'undefined') {
        // Check valid id card number
        // return this.idCardCheck(idCardNumber)
        return true;
      } else {
        return false;
      }
    },
    idCardCheck: function idCardCheck(idCardNumber) {
      var sum = 0;
      for (var i = 0; i < idCardNumber.length - 1; i++) {
        sum += parseInt(idCardNumber[i]) * (13 - i);
      }

      var checkDigit = (11 - sum % 11) % 10;

      if (checkDigit === idCardNumber[12]) {
        return true;
      } else {
        return false;
      }
    },
    checkUser: function checkUser() {
      if (localStorage.token === 'undefined' || localStorage.token === undefined || localStorage.token === null || localStorage.token === '') {
        localStorage.clear();
        this.$router.push('/');
      } else {
        this.checkToken(localStorage.token);
      }
    },
    checkToken: function checkToken(token) {
      var jwt = __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode___default.a.decode(token);
      var TimoOutLogin = this.daysDiff(jwt.create, jwt.expire);
      if (parseInt(TimoOutLogin) <= 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          icon: 'error',
          title: 'ตรวจสอบการใช้งาน',
          text: 'ท่านเข้าใช้งานเกินเวลาที่กำหนด'
        });
        localStorage.clear();
        this.$router.push('/');
      } else {
        this.getProfile();
      }
    },
    callbackToken: function callbackToken(citizenId) {
      if (localStorage.token === 'undefined' || localStorage.token === undefined || localStorage.token === null || localStorage.token === '') {
        return false;
      } else {
        var jwt = __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode___default.a.decode(localStorage.token);
        var TimoOutLogin = this.daysDiff(jwt.create, jwt.expire);
        if (parseInt(TimoOutLogin) > 0) {
          return true;
        } else {
          if (citizenId) {
            __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].OAuthCheck(this.$store.state.URL, { citizenId: citizenId }, this.header, function (result) {
              if (result.status === 'SUCCESS') {
                localStorage.token = result.data.accessToken;
                return true;
              } else if (result.status === 'NOT_REGISTER') {
                return false;
              } else {
                return false;
              }
            }, function (_error) {
              return false;
            });
          } else {
            return false;
          }
        }
      }
    },
    OAuth: function OAuth(citizenId) {
      var _this = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].OAuthCheck(this.$store.state.URL, { citizenId: citizenId }, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          localStorage.token = result.data.accessToken;
          _this.getProfile();
        } else if (result.status === 'NOT_REGISTER') {
          _this.$router.push('/regis?id=' + citizenId);
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'ตรวจสอบ',
            text: result.message,
            icon: 'warning',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'ตกลง'
          }).then(function (_result) {
            localStorage.clear();
            _this.$router.push('/');
          });
        }
        _this.$store.state.isLoading = false;
      }, function (_error) {
        _this.$store.state.isLoading = false;
        localStorage.clear();
        _this.$router.push('/');
      });
    },
    getProfile: function getProfile() {
      var _this2 = this;

      this.header.headers['Access-Token'] = localStorage.token;
      __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getProfile(this.$store.state.URL, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          _this2.$store.state.user = result.data;
          _this2.$store.state.isLoading = false;
        } else {
          _this2.$store.state.isLoading = false;
          localStorage.clear();
          _this2.$router.push('/');
        }
      }, function (_error) {
        localStorage.clear();
        _this2.$router.push('/');
        _this2.$store.state.isLoading = false;
      });
    },
    daysDiff: function daysDiff(d1, d2) {
      var startDate = moment(d1).format('x');
      // Do your operations
      var endDate = moment(d2).format('x');
      var seconds = (endDate - startDate) / 60000;
      return Math.floor(seconds);
    },
    dateYearThai: function dateYearThai(date) {
      return moment(date).format('YYYY');
    },
    dateMonth: function dateMonth(date) {
      return moment(date).format('YYYY-MM');
    },
    dateTimeFormat: function dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    dateFormat: function dateFormat(date) {
      return moment(date).format('L');
    },
    dateFormatDMY: function dateFormatDMY(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    dateFormatDMY2: function dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatMY: function dateFormatMY(date) {
      return moment(date).format('MM/YYYY');
    },
    monthFormat: function monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค';
        case '02':
          return 'ก.พ';
        case '03':
          return 'มี.ค';
        case '04':
          return 'เม.ย';
        case '05':
          return 'พ.ค';
        case '06':
          return 'มิ.ย';
        case '07':
          return 'ก.ค';
        case '08':
          return 'ส.ค';
        case '09':
          return 'ก.ย';
        case '10':
          return 'ต.ค';
        case '11':
          return 'พ.ย';
        default:
          return 'ธ.ค';
      }
    },
    monthYearFormat: function monthYearFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0];
        case '02':
          return 'กุมภาพันธ์ ' + date[0];
        case '03':
          return 'มีนาคม ' + date[0];
        case '04':
          return 'เมษายน ' + date[0];
        case '05':
          return 'พฤษภาคม ' + date[0];
        case '06':
          return 'มิถุนายน ' + date[0];
        case '07':
          return 'กรกฎาคม ' + date[0];
        case '08':
          return 'สิงหาคม ' + date[0];
        case '09':
          return 'กันยายน ' + date[0];
        case '10':
          return 'ตุลาคม ' + date[0];
        case '11':
          return 'พฤศจิกายน ' + date[0];
        default:
          return 'ธันวาคม ' + date[0];
      }
    },
    dateThaiFormat: function dateThaiFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + (parseInt(date[0]) + 543);
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + (parseInt(date[0]) + 543);
        case '03':
          return date[2] + ' มีนาคม ' + (parseInt(date[0]) + 543);
        case '04':
          return date[2] + ' เมษายน ' + (parseInt(date[0]) + 543);
        case '05':
          return date[2] + ' พฤษภาคม ' + (parseInt(date[0]) + 543);
        case '06':
          return date[2] + ' มิถุนายน ' + (parseInt(date[0]) + 543);
        case '07':
          return date[2] + ' กรกฎาคม ' + (parseInt(date[0]) + 543);
        case '08':
          return date[2] + ' สิงหาคม ' + (parseInt(date[0]) + 543);
        case '09':
          return date[2] + ' กันยายน ' + (parseInt(date[0]) + 543);
        case '10':
          return date[2] + ' ตุลาคม ' + (parseInt(date[0]) + 543);
        case '11':
          return date[2] + ' พฤศจิกายน ' + (parseInt(date[0]) + 543);
        default:
          return date[2] + ' ธันวาคม ' + (parseInt(date[0]) + 543);
      }
    },
    numberFormat: function numberFormat(str) {
      return numeral(str).format('0,0.00');
    },
    numberFormat2: function numberFormat2(str) {
      return numeral(str).format('00');
    },
    numberFormatold: function numberFormatold(str) {
      return numeral(str).format('0,0');
    }
  }
});

/***/ })

},[157]);


// WEBPACK FOOTER //
// static/js/app.faa4785c26124b559e85.js